var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLifeSummary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 0H7V4C7 4.5625 7.4375 5 8 5H12V14C12 15.125 11.0938 16 10 16H2C0.875 16 0 15.125 0 14V2C0 0.90625 0.875 0 2 0ZM8 0L12 4H8V0ZM3.5 8C3.21875 8 3 8.25 3 8.5C3 8.78125 3.21875 9 3.5 9H8.5C8.75 9 9 8.78125 9 8.5C9 8.25 8.75 8 8.5 8H3.5ZM3.5 10C3.21875 10 3 10.25 3 10.5C3 10.7812 3.21875 11 3.5 11H8.5C8.75 11 9 10.7812 9 10.5C9 10.25 8.75 10 8.5 10H3.5ZM3.5 12C3.21875 12 3 12.25 3 12.5C3 12.7812 3.21875 13 3.5 13H8.5C8.75 13 9 12.7812 9 12.5C9 12.25 8.75 12 8.5 12H3.5Z",
    fill: "url(#paint0_linear_40003245_47649)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_40003245_47649",
    x1: 6,
    y1: -2,
    x2: 6,
    y2: 18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB9B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4545"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLifeSummary);
export default __webpack_public_path__ + "static/media/lifeSummary.8137c44a1a2c3e21c0e57a98a8268cf9.svg";
export { ForwardRef as ReactComponent };